import { Box } from '@mui/material'
import { styled as muiStyled } from '@mui/material/styles';


const EmailSignatureStyles = muiStyled(Box)(({ }) => ({
    'a': {
        textDecoration: "none",
        color: "#26445A"
    },
    display: "flex",
    columnGap: 6,
    '.MuiButtonBase-root.MuiButton-root.MuiLoadingButton-root': {
        height: "35px !important"
    }
}));

export { EmailSignatureStyles }